import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

const chapters = [
  {
    n: "01",
    title: "Shuddhata",
    subtitle: "Purity · शुद्धता",
    text: "A state so clean in mind, body and soul that nothing negative can dwell in it — a stillness where the supreme resides. Our products are organic, natural and earthy, made with a sensitivity to nature at every step. Each one retells a story of simplicity, for the love of the Vedas — and the shuddhi of its making, from the first thought to the final craftsmanship, is uniquely ours.",
  },
  {
    n: "02",
    title: "Shilp",
    subtitle: "The Sacred Art of Creation · शिल्प",
    text: "The beauty of skilled hands transforming natural materials into meaningful forms. Rooted in the ancient tradition of Śilpa Śāstra — sculpture, icon-making, carving, painting and metalwork — shilp honours the patience and devotion of the artisan: giving physical form to thought, beauty and symbolism, so that every creation carries a touch of culture, purpose and bhakti.",
  },
  {
    n: "03",
    title: "Bhakti",
    subtitle: "Surrender, Devotion & Prerna · भक्ति",
    text: "Surrender, devotion and prerna — the divine inspiration that moves the hand. Every creation is made with affection and sensitivity, shaped by a deep imagination that brings the sacred into real life. We do not manufacture products; we prepare offerings.",
  },
];

export const Manifesto = () => (
  <section id="philosophy" data-testid="manifesto-section" className="border-y border-brand-border bg-brand-cream/40 py-28 lg:py-40">
    <div className="mx-auto max-w-7xl px-6 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: EASE }}
        className="mb-24"
      >
        <p className="text-[11px] font-medium uppercase tracking-[0.4em] text-brand-gold">Our Poojan Dharm</p>
        <h2 className="mt-6 max-w-3xl font-display text-4xl font-medium leading-tight text-brand-ink md:text-6xl">
          Three vows we <em className="italic text-brand-maroon">never break.</em>
        </h2>
      </motion.div>
      <div className="space-y-24 md:space-y-32">
        {chapters.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 48 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, delay: i * 0.1, ease: EASE }}
            className="relative grid grid-cols-1 gap-6 md:grid-cols-12"
            data-testid={`manifesto-chapter-${c.n}`}
          >
            <span
              aria-hidden="true"
              className="pointer-events-none absolute -top-16 left-0 select-none font-display text-[10rem] font-medium leading-none text-brand-border/70 md:-top-24 md:text-[16rem]"
            >
              {c.n}
            </span>
            <div className="relative md:col-span-4 md:col-start-2">
              <h3 className="font-display text-4xl font-medium text-brand-ink md:text-5xl">{c.title}</h3>
              <p className="mt-2 font-display text-xl italic text-brand-gold">{c.subtitle}</p>
            </div>
            <p className="relative max-w-xl text-base font-light leading-relaxed text-brand-ink/70 md:col-span-6 md:col-start-7 md:text-lg">
              {c.text}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
